<app-edit-component-base (onCancel)="cancel()" (onNextView)="setCurrentStep(currentStep * 2)"
                         (onPreviousView)="setCurrentStep(currentStep / 2)"
                         (onSave)="save()"
                         [id]="persistence.Id"
                         [templates]="{'1': GeneralInformation, '2': LegalInformation, '4': TaxInformation, '8': CommunicationInformation, '16': Shards}"
                         [title]="'Unternehmen ' + (editing ? 'bearbeiten' : 'anlegen')" [view]="currentStep">
  <ng-container steps>
    @for (step of CompanyCreateStepsList; track step) {
      <li editComponentStep [model]="step" [current]="currentStep" [index]="$index"
          [label]="CompanyCreateStepsLabels[step]"
          (currentChange)="setCurrentStep($event)">
      </li>
    }
  </ng-container>

  <ng-template #GeneralInformation>
    @if (persistence.entity) {
      <configuration-segment description="" title="Allgemeine Informationen">
        <configuration-input-field [(value)]="persistence.entity.name" [required]="true" autocomplete="company-name"
                                   class="sm:col-span-6"
                                   id="company-name" label="Firmenname"
                                   name="company-name" placeholder="Musterfirma">
                <span class="">
                  <span class="select-all">{{ persistence.entity.id ?? "Neu" }}</span>
                  /
                </span>
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.alias" [required]="true" autocomplete="off"
                                   class="sm:col-span-6" id="company-alias" label="Kürzel"
                                   name="company-alias" placeholder="z.B. MF">
        </configuration-input-field>
      </configuration-segment>
      <configuration-segment description="" title="Adresse">
        <configuration-input-field [(value)]="persistence.entity.address.street"
                                   [required]="true" autocomplete="address-street" class="col-span-full"
                                   id="address-street" label="Straße" name="address-street"
                                   placeholder="Musterstr.">
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.address.houseNumber"
                                   autocomplete="address-house-number" class="col-span-4"
                                   id="address-house-number" label="Hausnummer"
                                   name="address-house-number" placeholder="123"
                                   validationPattern="^[0-9]+$">
        </configuration-input-field>
        <configuration-input-field
          (valueChange)="persistence.entity.address.houseNumberSuffix = $event.isNullOrWhitespace() ? undefined : $event"
          [value]="persistence.entity.address.houseNumberSuffix ?? ''"
          autocomplete="address-house-number-suffix" class="col-span-2"
          id="address-house-number-suffix" label="Hausnummernzusatz"
          name="address-house-number-suffix" placeholder="a" validationPattern=".{0,20}">
        </configuration-input-field>

        <configuration-input-field
          (valueChange)="persistence.entity.address.additionalAddressLine = $event.isNullOrWhitespace() ? undefined : $event"
          [value]="persistence.entity.address.additionalAddressLine ?? ''" autocomplete="address-additional"
          class="col-span-full" id="address-additional"
          label="Adresszusatz"
          name="address-additional"
          placeholder="z.B. Hinterhaus">
        </configuration-input-field>

        <configuration-input-field [(value)]="persistence.entity.address.zipCode"
                                   [required]="true" autocomplete="address-zip-code"
                                   class="col-span-full sm:col-span-2" id="address-zip-code"
                                   label="Postleitzahl"
                                   name="address-zip-code" placeholder="12345">
        </configuration-input-field>

        <configuration-input-field [(value)]="persistence.entity.address.city"
                                   [required]="true" autocomplete="address-city" class="col-span-full sm:col-span-2"
                                   id="address-city"
                                   label="Stadt" name="address-city"
                                   placeholder="Musterstadt">
        </configuration-input-field>

        <div class="sm:col-span-2">
          <label class="block text-sm/6 font-medium text-gray-900" for="country">Land*</label>
          <div class="mt-2 grid grid-cols-1">
            <select autocomplete="country-name"
                    class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline sm:text-sm/6"
                    id="country"
                    name="country">
              <option>Deutschland</option>
            </select>
            <svg aria-hidden="true"
                 class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                 data-slot="icon"
                 viewBox="0 0 16 16">
              <path
                clip-rule="evenodd"
                d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                fill-rule="evenodd"/>
            </svg>
          </div>
        </div>
      </configuration-segment>
    }

  </ng-template>

  <ng-template #LegalInformation>
    @if (persistence.entity) {
      <configuration-segment [useDefaultTitle]="false">
        <ng-container header>
          <div>
            <div class="grid grid-cols-1 sm:hidden pt-4">
              <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
              <select (ngModelChange)="persistence.entity.setLegalType(parseInt($event))"
                      [ngModel]="persistence.entity.legalInformation.legalType"
                      aria-label="Rechtsart wählen"
                      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300">
                @for (type of LegalTypeList; track type) {
                  <option [value]="type"
                          [selected]="type == persistence.entity.legalInformation.legalType">{{ LegalTypeLabels[type] }}
                  </option>
                }
              </select>
              <svg aria-hidden="true"
                   class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
                   data-slot="icon"
                   viewBox="0 0 16 16">
                <path
                  clip-rule="evenodd"
                  d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                  fill-rule="evenodd"/>
              </svg>
            </div>
            <div class="hidden sm:block">
              <div class="border-b border-gray-200">
                <nav aria-label="Tabs" class="-mb-px flex space-x-8">
                  @for (type of LegalTypeList; track type) {
                    <!-- Current: "border-theme-primary-700 text-theme-primary-700", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
                    <a (click)="persistence.entity.setLegalType(type)"
                       class="group inline-flex items-center border-b-2 border-transparent px-1 pb-2 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                       [ngClass]="{'!border-theme-primary-700 text-theme-primary-700': type == persistence.entity.legalInformation.legalType}">
                      <!-- Current: "text-theme-primary-700", Default: "text-gray-400 group-hover:text-gray-500" -->
                      <svg viewBox="0 0 20 20" data-slot="icon" aria-hidden="true"
                           class="-ml-0.5 mr-2 size-5 text-gray-400 group-hover:text-gray-500"
                           [ngClass]="{'text-theme-primary-700': type == persistence.entity.legalInformation.legalType}">
                        @switch (type) {
                          @case (LegalType.NaturalPerson) {
                            <path
                              d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"/>
                          }
                          @case (LegalType.LegalEntity) {
                            <path
                              d="M4 16.5v-13h-.25a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5H16v13h.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5H4Zm3-11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                              clip-rule="evenodd" fill-rule="evenodd"/>
                          }
                        }
                      </svg>
                      <span>{{ LegalTypeLabels[type] }}</span>
                    </a>
                  }
                </nav>
              </div>
            </div>
          </div>
        </ng-container>

        @switch (persistence.entity.legalInformation.legalType) {
          @case (LegalType.LegalEntity) {
            <configuration-input-field class="col-span-full"
                                       id="company-name" name="company-name" autocomplete="company-name"
                                       label="Firmenname" placeholder="Musterfirma"
                                       [(value)]="persistence.entity.legalInformation.asAny().name"
                                       [required]="true">
            </configuration-input-field>
            <div class="sm:col-span-6">
              <!--
                `for` must name the INNER input ng-select renders, not the `<ng-select>` host: a custom element
                is not labelable, so `for="legal-form"` left this combobox unlabelled (axe `label`, critical).
                `labelForId` is ng-select's own hook for that id.
              -->
              <label for="legal-form-input" class="text-sm/6 font-medium text-gray-900 inline-flex gap-x-1">
                Rechtsform*
              </label>
              <!--
                #236: this page is built on `app-edit-component-base`, which projects its content INSIDE
                `layout-page-scrollable` — whose `.page-scroller` is the page's scroll container and used to
                slice the option list off. `.page-viewport` is `layout-page-container`'s own box: positioned
                (`absolute inset-0`, so it can be the panel's containing block) and one level ABOVE
                `.page-scroller`, i.e. outside the clip. `NgSelectScrollAwareDirective` rides along on the
                `ng-select[appendTo]` selector and keeps the panel glued to the input while that box scrolls.
              -->
              <ng-select id="legal-form" class="mt-2 ng-select cheqme-style text-sm" [clearable]="false"
                         appendTo=".page-viewport" labelForId="legal-form-input"
                         [(ngModel)]="persistence.entity.legalInformation.asAny().legalForm">
                @for (form of LegalFormList; track form) {
                  <ng-option [value]="form">{{ LegalFormDescription[form] }}</ng-option>
                }
              </ng-select>
            </div>
          }
          @case (LegalType.NaturalPerson) {
            <div class="col-span-full sm:col-span-2">
              <!-- `for` names the inner input, see the note on "Rechtsform" above. -->
              <label for="salutation-input" class="text-sm/6 font-medium text-gray-900 inline-flex gap-x-1">
                Anrede*
              </label>
              <!-- #236: portaled out of `.page-scroller`; see the note on "Rechtsform" above. -->
              <ng-select id="salutation" class="mt-2 ng-select cheqme-style text-sm" [clearable]="false"
                         appendTo=".page-viewport" labelForId="salutation-input"
                         [(ngModel)]="persistence.entity.legalInformation.asAny().salutation">
                @for (salutation of SalutationList; track salutation) {
                  <ng-option [value]="salutation">{{ SalutationLabels[salutation] }}</ng-option>
                }
              </ng-select>
            </div>
            <configuration-input-field class="col-span-full sm:col-start-1 sm:col-span-3"
                                       id="first-name" name="first-name" autocomplete="given-name"
                                       label="Vorname" placeholder="Max"
                                       [(value)]="persistence.entity.legalInformation.asAny().firstName"
                                       [required]="true">
            </configuration-input-field>

            <configuration-input-field class="col-span-full sm:col-span-3"
                                       id="last-name" name="last-name" autocomplete="family-name"
                                       label="Nachname" placeholder="Mustermann"
                                       [(value)]="persistence.entity.legalInformation.asAny().lastName"
                                       [required]="true">
            </configuration-input-field>

            <configuration-input-field class="col-span-full sm:col-span-2"
                                       id="birth-date" name="birth-date" autocomplete="bday"
                                       label="Geburtsdatum" placeholder="01.01.2000"
                                       [(value)]="persistence.entity.legalInformation.asAny().dateOfBirth"
                                       type="date" [required]="true">
            </configuration-input-field>

            <configuration-input-field class="col-span-full sm:col-span-3 sm:col-start-4"
                                       id="identification-number" name="identification-number"
                                       autocomplete="identification-number"
                                       label="Identifikationsnummer" placeholder="12345678901"
                                       validationPattern="^[0-9]{11}$" [required]="true"
                                       [(value)]="persistence.entity.legalInformation.asAny().identificationNumber">
              <span>XXXXXXXXXX</span>
            </configuration-input-field>
          }
        }
      </configuration-segment>
    }
  </ng-template>

  <ng-template #TaxInformation>
    @if (persistence.entity) {
      <configuration-segment description="" title="Steuerinformationen">
        <configuration-input-field [(value)]="persistence.entity.taxInformation.taxNumber" [required]="true"
                                   autocomplete="tax-number"
                                   class="col-span-full" id="tax-number" label="Steuernummer"
                                   name="tax-number"
                                   placeholder="Steuernummer" validationPattern="^[0-9]{4}0[0-9]{8}$">
          <span>XXXX0XXXXXXXX</span>
        </configuration-input-field>
        <configuration-input-field
          (valueChange)="persistence.entity.taxInformation.vatNumber = $event.isNullOrWhitespace() ? undefined : $event"
          [value]="persistence.entity.taxInformation.vatNumber ?? ''" autocomplete="tax-number"
          class="col-span-full" id="vat-number" label="USt.-ID"
          name="vat-number"
          placeholder="DE123456789"
          validationPattern="^(DE[0-9]{9}|)$">
          <span>DEXXXXXXXXX</span>
        </configuration-input-field>
      </configuration-segment>
    }
  </ng-template>

  <ng-template #CommunicationInformation>
    @if (persistence.entity) {
      <configuration-segment description="Pflicht-Kontaktadressen des Unternehmens." title="Kommunikation">
        <configuration-input-field [(value)]="persistence.entity.communicationInformation.email_GDPR"
                                   [required]="true" autocomplete="email" type="email"
                                   class="col-span-full" id="email-gdpr" label="E-Mail (Datenschutz)"
                                   name="email-gdpr" placeholder="datenschutz@musterfirma.de">
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.communicationInformation.email_Administrative"
                                   [required]="true" autocomplete="email" type="email"
                                   class="col-span-full" id="email-admin" label="E-Mail (Verwaltung)"
                                   name="email-admin" placeholder="verwaltung@musterfirma.de">
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.communicationInformation.email_Invoicing"
                                   [required]="true" autocomplete="email" type="email"
                                   class="col-span-full" id="email-invoicing" label="E-Mail (Rechnung)"
                                   name="email-invoicing" placeholder="rechnung@musterfirma.de">
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.communicationInformation.email_Operations"
                                   autocomplete="email" type="email"
                                   class="col-span-full" id="email-operations" label="E-Mail (Betrieb, optional)"
                                   name="email-operations" placeholder="betrieb@musterfirma.de"
                                   hint="Erhält eine Kundenbenachrichtigung, wenn ein Kassenabschluss oder E-Beleg endgültig nicht übermittelt werden konnte. Die interne Warnung geht immer an die IT-Adresse der Plattform, nie an die Verwaltungsadresse.">
        </configuration-input-field>
      </configuration-segment>
    }
  </ng-template>

  <ng-template #Shards>
    @if (persistence.entity) {
      <configuration-segment description="" title="Shards">
        <!-- Track by object reference, not shard.id: newly added shards all have an
             undefined id until the company is saved, which would collide on a keyed track. -->
        @for (shard of persistence.entity.shards; track shard; let index = $index) {
          <configuration-input-field class="col-span-full" label="Shard {{ index + 1 }}"
                                     id="shard-{{ shard.id }}" name="shard-{{ shard.id }}" autocomplete="shard"
                                     [value]="shard.name" [readonly]="true"
                                     [hasButton]="true" buttonText="Bearbeiten"
                                     (clicked)="editShard(shard)">
                <span>
                  <span class="select-all">{{ shard.id ?? "Neu" }}</span>
                  /
                </span>
          </configuration-input-field>
        } @empty {
          <p class="col-span-full text-sm text-gray-500 italic py-6 border-2 border-dashed border-gray-100 rounded-2xl text-center">
            Noch keine Shards angelegt.
          </p>
        }

        <div class="col-span-full flex justify-center">
          <!-- editShard() with no argument seeds a fresh `new Shard()` (id === undefined),
               opening the shard editor in create mode; on save it is pushed to the array. -->
          <button type="button" (click)="editShard()"
                  class="inline-flex items-center justify-center px-5 py-2.5 bg-theme-primary-600 text-white rounded-2xl
                         hover:bg-theme-primary-700 font-semibold shadow-lg shadow-theme-primary-100 hover:shadow-xl
                         transition-all duration-200 active:scale-95">
            <svg class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10 5a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 10 5Z"/>
            </svg>
            Shard hinzufügen
          </button>
        </div>
      </configuration-segment>
    }
  </ng-template>
</app-edit-component-base>
